import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GrammatechCodeSentryMappingForm from './GrammatechCodeSonarMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function GrammatechCodeSonarCredentialForm(props, ref) {
    const fields = useMemo(() => {
        return [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator]
        }, {
            name: "username",
            label: "Username",
            required: true,
        }, {
            name: "password",
            label: "Password",
            type: FieldTypes.PASSWORD,
            required: true
        }]
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={GrammatechCodeSentryMappingForm}
        />
    )
}

export default forwardRef(GrammatechCodeSonarCredentialForm);